import { cn } from '@/utils/сn';

type ToggleSwitchProps = {
  checked: boolean;
  onChange: () => void;
  disabled?: boolean;
};

export const ToggleSwitch = ({ checked, onChange, disabled = false }: ToggleSwitchProps) => (
  <button
    type="button"
    onClick={onChange}
    disabled={disabled}
    className={cn(
      'relative w-11 h-6 rounded-full p-0.5 flex items-center flex-shrink-0 transition-colors',
      disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer',
      checked ? 'bg-blue-200 justify-end' : 'bg-blue-100 justify-start'
    )}
  >
    <div className="w-5 h-5 bg-white rounded-full shadow-[0px_1px_2px_rgba(16,24,40,0.06),0px_1px_3px_rgba(16,24,40,0.10)]" />
  </button>
);
